import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchPrepayments } from '../../../../actions/prepayment/prepaymentList'
import Prepayments from '../../Prepayments'
import { AppState } from '../../../../reducers'
import { PrepaymentListState } from '../../../../reducers/prepayment/prepaymentList'
import { useTranslation } from 'react-i18next'
import { SessionState } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { fetchPendingPreorder } from '../../../../actions/preorder/preorder'
import { PreorderDataState } from '../../../../reducers/preorder/preorderData'
import { fetchPreorders } from '../../../../actions/preorder/preorderList'
import { PreorderListState } from '../../../../reducers/preorder/preorderList'
import { useThemeContext } from '../../../../theme/ThemeContext'

interface Props {
  prepaymentList: PrepaymentListState
  preorderList: PreorderListState
  preorder: PreorderDataState
  session: SessionState
}

const SelectPrepayments: React.FC<Props> = ({ prepaymentList, preorder, preorderList, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['preorder'])
  const [reading, setReading] = useState<boolean>(true)
  const { theme } = useThemeContext()

  useEffect(() => {
    dispatch(fetchPendingPreorder())
    dispatch(fetchPreorders())
  }, [dispatch])

  useEffect(() => {
    if (!reading )
    {
      if (preorder.preorder && preorder.preorder.id && preorder.preorder.prepaymentId)
      linkToStatePreorderWithPrepayment(preorder.preorder.prepaymentId)
    if (preorder.preorder && preorder.preorder.id && !preorder.preorder.prepaymentId)
      linkToStatePreorderWithPrepayment(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps        
  }, [preorder.preorder])

  useEffect(() => {
    dispatch(fetchPrepayments('?status=ACTIVO'))
    setReading(false)
  }, [dispatch])

  
  const linkToStatePreorderWithPrepayment = (prepaymentId: string | undefined ) => {
    setReading(false)
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/preorders/main`
    history.push(detailUrl, { prepaymentId: prepaymentId })
  }


  const linkToPreorderWithPrepayment = (prepaymentId: string) => {
    setReading(false)
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/preorders/delivery/${prepaymentId}`
    history.push(detailUrl)
  }

  const linkToPreorderWithoutPrepayment = () => {
    setReading(false)
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/preorders/delivery`
    history.push(detailUrl)
  }

  const constructRows = () => {
    const rows = (prepaymentList.prepayments || []).filter((pp) => pp.fecha >= '2024-06-18' && 
       preorderList.preorders?.every((po) => (po.status !== 'A' && po.status !== 'P' && po.status !== 'H' && po.status !== 'C') || po.prepaymentId !== pp.id_acopio ) ).map(s => ({ data: s }))
    const inUseA = (prepaymentList.prepayments || []).filter((pp) => 
      preorderList.preorders?.some((po) => (po.status === 'A') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'A', user: '', data: s }));
    const inUseP = (prepaymentList.prepayments || []).filter((pp) => 
      preorderList.preorders?.some((po) => (po.status === 'P') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'P', user: '', data: s }));
    const inUseH = (prepaymentList.prepayments || []).filter((pp) => 
      preorderList.preorders?.some((po) => (po.status === 'H') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'H', user: '', data: s }));   
    const inUseC = (prepaymentList.prepayments || []).filter((pp) =>
      preorderList.preorders?.some((po) => (po.status === 'C') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'C', user: '', data: s }));
    const inUseN = (prepaymentList.prepayments || []).filter((pp) => pp.fecha < '2024-06-18').map(s => ({ action: "disabled", statusPO: 'N', user: '', data: s }));
    
    inUseA.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseP.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseH.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseC.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseN.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
   
    return rows.concat(inUseA).concat(inUseP).concat(inUseH).concat(inUseC).concat(inUseN).sort((a, b) => a.data.fecha > b.data.fecha ? -1 : a.data.fecha < b.data.fecha ? 1 : 0 );
  }

  return (
    <>
      {!reading && !prepaymentList.isFetching &&
        <Stack display="flex" flexDirection='column' alignItems="left" padding="10px">
          <Prepayments
            rows={constructRows()}
            loading={prepaymentList.isFetching || preorderList.isFetching || reading}
            fullInfo={false}
            toPreorder={true}
            pagination={prepaymentList.pagination || undefined}
            showInPreorder={true}
            onClickDetail={linkToPreorderWithPrepayment}
          />
          <Stack display="flex" flexDirection="row" alignItems="left" padding="10px" paddingTop="50px">
            <Button aria-label="back" size='large' style={{ textTransform: 'none' }} onClick={linkToPreorderWithoutPrepayment}>
              <Typography style={{color: theme.palette.success.dark }} variant="h6">{t('doWithoutPrepayment')}</Typography>
            </Button>
          </Stack>
        </Stack>
      }
      {(reading || prepaymentList.isFetching) &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  prepaymentList: state.prepaymentList,
  preorder: state.preorderData,
  preorderList: state.preorderList,
  session: state.session
})

export default connect(mapStateToProps, null)(SelectPrepayments)